import { ITreeExpandable, instanceOfITreeExpandable } from "../../../system";

export interface IFormatTreeSelectable extends ITreeExpandable {
  selectDirectoryNode(key: string): boolean;
}

export function instanceOfIFormatTreeSelectable(instance: any): instance is IFormatTreeSelectable {
  return instance
    && (instance.selectDirectoryNode !== undefined)
    && instanceOfITreeExpandable(instance);
}
